import { FieldArray, Form, Formik } from "formik";
import React from "react";
import FormInput from "../../../../Universal/FormInput.component";
import PlusIcon from "../../../../../assets/Icons/Universal/PlusIconWithGreenBack.svg";
const AddNewPosition = ({ outputData }) => {
  return (
    <Formik
      initialValues={{
        positionNames: [""],
      }}
      onSubmit={(values) => {
        outputData(values);
      }}
    >
      {({ values, errors, touched }) => (
        <Form className="flex-col align-left justify-start g-2 w-full">
          <div className="flex-col align-left justify-start g-1 w-full">
            <FieldArray name="positionNames">
              {({ push }) => (
                <>
                  {values.positionNames.map((_, index) => (
                    <FormInput
                      label="Position"
                      placeholder="Enter a position"
                      name={`positionNames[${index}]`}
                      type="text"
                      errors={errors}
                      touched={touched}
                    />
                  ))}
                  <button
                    type="button"
                    onClick={() => push("")}
                    className="addNewFieldBtn"
                  >
                    <img src={PlusIcon} alt="Add" />
                    <span>Add</span>
                  </button>
                </>
              )}
            </FieldArray>
          </div>

          <button type="submit" className="actionBtn w-full">
            Update
          </button>
        </Form>
      )}
    </Formik>
  );
};

export default AddNewPosition;
